// ═══════════════════════════════════════════════════════════════
// INTERFACES & TYPES
// ═══════════════════════════════════════════════════════════════

interface PfRegistrationCardProps {
    registration: any;
    cleanDoc: string;
}

// ═══════════════════════════════════════════════════════════════
// HELPER FUNCTIONS
// ═══════════════════════════════════════════════════════════════

const renderField = (label: string, value: string | number | null | undefined) => (
    <div className="py-1.5 border-b border-gray-100 dark:border-slate-600">
        <div className="text-xs font-medium text-gray-500 dark:text-gray-400">{label}</div>
        <div className="text-sm text-gray-900 dark:text-gray-100">{value != null && value !== '' ? String(value) : <span className="text-gray-400 italic">-</span>}</div>
    </div>
);

// ═══════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════

export default function PfRegistrationCard({ registration, cleanDoc }: PfRegistrationCardProps) {
    if (!registration) {
        return <div className="text-gray-500 text-center py-8">Dados de pessoa física não disponíveis. Bureau ainda não foi consultado.</div>;
    }

    return (
        <div className="space-y-4">
            <div className="border-2 border-green-300 dark:border-green-600 bg-green-50 dark:bg-slate-700 rounded p-4">
                <span className="text-xs font-bold text-green-600 dark:text-green-400 uppercase mb-2 block">
                    Pessoa Física — {registration._bureau || 'Bureau'}
                </span>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-0">
                    {renderField('Nome', registration.consumerName)}
                    {renderField('CPF', registration.documentNumber || cleanDoc)}
                    {renderField('Nome da Mãe', registration.motherName)}
                    {renderField('Data de Nascimento', registration.birthDate)}
                    {renderField('Sexo', registration.consumerGenderDescription || registration.consumerGender)}
                    {renderField('Situação CPF', registration.statusRegistration)}
                    {renderField('Data Situação', registration.statusDate)}
                </div>
                {registration._score && (
                    <div className="mt-3 p-3 bg-white dark:bg-slate-800 rounded border border-green-200 dark:border-green-700">
                        <div className="text-xs font-semibold text-green-600 dark:text-green-400 uppercase mb-1">Score</div>
                        <div className="grid grid-cols-3 gap-4 text-sm">
                            {renderField('Score', registration._score.score)}
                            {renderField('Probabilidade Default', registration._score.defaultRate || registration._score.probabilityOfDefault)}
                            {renderField('Classe', registration._score.scoreClass || registration._score.riskClass)}
                        </div>
                    </div>
                )}
                {registration.address && (
                    <div className="mt-3">
                        <div className="text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase mb-1">Endereço</div>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4">
                            {renderField('Logradouro', registration.address.addressLine)}
                            {renderField('Bairro', registration.address.district)}
                            {renderField('Cidade/UF', `${registration.address.city || ''}/${registration.address.state || ''}`)}
                            {renderField('CEP', registration.address.zipCode)}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
